import { Button, Card, CardBody, Flex } from '@chakra-ui/react'
import { organizationListContext } from 'BrokerTsLib/src/context'
import type { OrganizationUnitPagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { useNavigate } from 'react-router'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { Pagination } from '@/containers/Pagination'
import { PageWrapper } from '@/layouts/components/PageWrapper'

import { ExportButton } from '@/containers/export/ExportButton'
import { ExportWrapper } from '@/containers/export/ExportWrapper'
import { ExportForm } from 'BrokerTsLib/src/containers'
import { ExportGroup } from 'BrokerTsLib/src/enums'
import { useState } from 'react'
import { OrganizationsList } from '../../containers/organization/OrganizationList'
import { OrganizationListFilter } from '../../containers/organization/OrganizationListFilter'
import { PageToolbar } from '../../containers/PageToolbar'
import { Add } from '../../icons'

const defaultPageSize = 15
export const OrganizationListPage = () => {
  const [filter, setFilter] =
    useSearchParamsStatePersistance<OrganizationUnitPagedQuery>(
      {
        name: '',
        showInvalid: false,
        showRootOnly: true,
        pageIndex: 1,
        pageSize: defaultPageSize,
      },
      [],
      ['showRootOnly'],
    )
  const navigate = useNavigate()

  const { data, isLoading: isLoading, refetch } = useGetAll(filter)
  const items = data?.data

  const [isExportOpen, setExportOpen] = useState(false)

  return (
    <PageWrapper
      header={<DashboardHeader title="Přehled organizací" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 4,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      <organizationListContext.Provider
        value={{
          loading: isLoading,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? defaultPageSize,
          filter: filter,
          setCurrentPage: (p: number) => setFilter(f => ({ ...f, pageIndex: p })),
          setPageSize: (s: number) => setFilter(f => ({ ...f, pageSize: s })),
          updateFilter: setFilter,
          reload: () => refetch(),
        }}
      >
        <PageToolbar
          rightElements={
            <Flex sx={{ gap: 4 }}>
              <ExportButton isExportOpen={isExportOpen} setExportOpen={setExportOpen} />

              <Button
                colorScheme="primary"
                onClick={() => navigate('/organization/create')}
              >
                <Add />
                Vytvořit novou organizaci
              </Button>
            </Flex>
          }
        />

        {isExportOpen && <ExportWrapper>
          <ExportForm group={ExportGroup.OrganizationUnit} />
        </ExportWrapper>}

        <Card>
          <CardBody>
            <OrganizationListFilter p={4} />
            <OrganizationsList organizations={items?.items ?? []} />
            <Pagination context={organizationListContext} />
          </CardBody>
        </Card>
      </organizationListContext.Provider>
    </PageWrapper>
  )
}
